function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var cookieConsentHtml = "\n<div class=\"cookie-consent\">\n  <p class=\"cookie-text\">\u3053\u306E\u30A6\u30A7\u30D6\u30B5\u30A4\u30C8\u3067\u306F\u30B5\u30A4\u30C8\u306E\u5229\u4FBF\u6027\u306E\u5411\u4E0A\u3092\u76EE\u7684\u306B\u30AF\u30C3\u30AD\u30FC\u3092\u4F7F\u7528\u3057\u307E\u3059\u3002\u30D6\u30E9\u30A6\u30B6\u306E\u8A2D\u5B9A\u306B\u3088\u308A\u30AF\u30C3\u30AD\u30FC\u306E\u6A5F\u80FD\u3092\u5909\u66F4\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002<br>\u8A73\u7D30\u306F<a href=\"/cookie\" target=\"_blank\">\u30AF\u30C3\u30AD\u30FC\u30DD\u30EA\u30B7\u30FC\u306B\u3064\u3044\u3066</a>\u3092\u3054\u89A7\u304F\u3060\u3055\u3044\u3002\u30B5\u30A4\u30C8\u3092\u95B2\u89A7\u3044\u305F\u3060\u304F\u969B\u306B\u306F\u3001\u30AF\u30C3\u30AD\u30FC\u306E\u4F7F\u7528\u306B\u540C\u610F\u3044\u305F\u3060\u304F\u5FC5\u8981\u304C\u3042\u308A\u307E\u3059\u3002</p>\n  <button class=\"cookie-agree\">\u540C\u610F\u3059\u308B</button>\n</div>\n";
(function () {
  // 同意ポップアップのHTMLを<footer>の後ろに挿入する
  var footerElement = document.getElementsByTagName('footer');
  footerElement[0].insertAdjacentHTML('afterend', cookieConsentHtml);

  // DOMを取得する
  var cookieConsent = document.querySelector('.cookie-consent');
  var cookieAgree = document.querySelector('.cookie-agree');

  // 保存されているCookieを取得
  var cookieData = document.cookie;

  // CookieをSetしているかどうかを判定するためのFlag
  var cookieSetFlag = false;

  // Cookie同意フラグがあるかどうか調べる
  var cookieDataList = cookieData.split('; ');
  var _iterator = _createForOfIteratorHelper(cookieDataList),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cookie = _step.value;
      var cookieSplit = cookie.split('=');

      // Cookie同意が取れていればフラグを立てる
      if (cookieSplit[0] === 'cookie-agree') {
        cookieSetFlag = true;
      }
    }

    // Cookieの有効期限の設定
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var expires = 31;

  // Cookie同意のCookieをセットする
  function SetCookie(expires) {
    var current = new Date();
    current.setDate(current.getDate() + expires);
    // console.log(current)
    document.cookie = "cookie-agree=yes; path=/; expires=".concat(current);
  }

  // 同意ボタンをクリックしたときCookieをセットする
  cookieAgree.addEventListener('click', function () {
    cookieConsent.classList.remove('active');
    SetCookie(expires);
  });

  // Cookie同意が無ければメッセージを表示する
  if (!cookieSetFlag) {
    cookieConsent.classList.add('active');
  }
})();